module.exports = __webpack_public_path__ + "static/media/04.c7bd61f1.jpg";